import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import ProfileMarkerService from './ProfileMakerService';
import { Tooltip } from 'bootstrap';

type PlatformUsageProps = {
    repliedMessgaeStudentToAlumni: { label: string; toolTip: string };
    loggedIntoPlatform : { label: string; toolTip: string };
    deepProfileUpdation: { label: string; toolTip: string };
    sendMSGToOtherAlumni: { label: string; toolTip: string };
    jobPosts: { label: string; toolTip: string };
    albums: { label: string; toolTip: string };
    viewAlumniProfiles:  { label: string; toolTip: string };
};

const PlatformUsageProps: PlatformUsageProps = {
    repliedMessgaeStudentToAlumni: {
        label: 'Replied to Messages from Students and Alumni',
        toolTip: 'Alumnus has replied to messages from students or other alumni.',
    },
    loggedIntoPlatform: {
        label: 'Logged in to Platform',
        toolTip: 'Alumnus has logged into the platform in last 6 months.',
    },
    deepProfileUpdation: {
        label: 'Deep Profile Updation',
        toolTip: 'Alumnus has updated the profile sections like achievement, skills, preferences, benefits etc.',
    },
    sendMSGToOtherAlumni: {
        label: 'Sent Messages to Other Alumni',
        toolTip: 'Alumnus has replied to messages to other alumni.',
    },
    viewAlumniProfiles: {
        label: 'Viewed Other Alumni Profiles',
        toolTip: 'Alumnus has viewed profiles of other alumni.',
    },
    jobPosts: {
        label: 'Given Job posts',
        toolTip:
            'Alumnus has contributed jobs and internships on Univariety platform for current students and alumni.',
    },
    albums: {
        label: 'Given Albums',
        toolTip: 'Alumnus has contributed memory albums on Univariety platform.',
    },
};

const keys = Object.keys(PlatformUsageProps) as (keyof PlatformUsageProps)[];

const PlatformUsage = () => {
    const { fetchPlatformUsageRelatedCountsByUserId, handleOpenLogsModal } = ProfileMarkerService();

    const [countData, setCountData] = useState<null | {
        jobPostCount: number;
        albumCount: number;
        repliedToMessagesCount: number;
        sentMessagesToAlumniCount: number;
        deepProfileUpdation :number;
        loggedIntoPlatform:number;
        viewAlumniProfiles: number;
    }>(null);

    const { state, dispatch } = useContext(SmartContext);

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, [state.data.platformusage]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const domainMap = new Map([...state.domain]);
                const countsData = await fetchPlatformUsageRelatedCountsByUserId(
                    state.internal.model.id               
                 );
                console.log('countData fetched', countsData);
                setCountData(countsData);

                dispatch({
                    type: 'DATA_INIT',
                    payload: {
                        data: {
                            ...state.data,
                            platformusage: {
                                ...state.data.marker?.platformusage,
                            },
                            visibleControl: {},
                        },
                        domain: domainMap,
                        internal: state.internal,
                        routeInfo: state.routeInfo,
                    },
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const getCountForKey = (key: string) => {
        if (!countData) return 0;

        switch (key) {
            case 'albums':
                return countData.albumCount;
            case 'jobPosts':
                return countData.jobPostCount;
            case 'repliedMessgaeStudentToAlumni':
                return countData.repliedToMessagesCount;
            case 'sendMSGToOtherAlumni':
                return countData.sentMessagesToAlumniCount;
            case 'deepProfileUpdation' :
                return countData.deepProfileUpdation;
            case 'loggedIntoPlatform' :
                return countData.loggedIntoPlatform;
            case 'viewAlumniProfiles' :
                return countData.viewAlumniProfiles;
            default:
                return 0;
        }
    };

    if (!countData) {
        return <div>Loading platform usage data...</div>;
    }

    return (
        <div
            className="tab-pane fade show active"
            id="pills-platform-usage"
            role="tabpanel"
            aria-labelledby="pills-platform-usage-tab">
            <div className="d-flex flex-wrap flex-column flex-md-row">
                <div
                    className="nav flex-row flex-md-column nav-pills custom-sub-tab"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"></div>
                <div
                    className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 flex-1"
                    id="v-pills-tabContent">
                    <div
                        className="tab-pane fade show active"
                        id="v-pills-campaign"
                        role="tabpanel"
                        aria-labelledby="v-pills-campaign-tab">
                        <div className="max-540 mx-auto">
                            <div className="row g-3">
                                {keys.map((key) => {
                                    const count = getCountForKey(key);
                                    const borderClass = count > 0 ? '' : 'disabled';

                                    return (
                                        <div className="col-12" key={key}>
                                            <div className="row g-3 align-items-center">
                                                <div className="col">
                                                    <div className={`listed-border ${borderClass}`}>
                                                        <i className="tick"></i>
                                                     <p>
                                                        {PlatformUsageProps[key].label}
                                                        {
                                                            key != 'deepProfileUpdation'
                                                             ? (count > 0 ? ` : ${count}` : '')
                                                             : ''
                                                        }
                                                    </p> 
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <i
                                                        className="icon-info"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-original-title={PlatformUsageProps[key].toolTip}
                                                        aria-label={PlatformUsageProps[key].toolTip}></i>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="col-12 pt-3">
                                    <button
                                        className="btn btn-dark-blue w-auto height-40 px-4 d-flex align-items-center mx-auto"
                                        onClick={() => handleOpenLogsModal()}>
                                        <span className="text-white">View Update Logs</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlatformUsage;
